import { addDays } from "date-fns";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { toDateString } from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";

/**
 * Bande de sélection de date (14 jours à partir d'aujourd'hui).
 */
export const DateStrip = ({ selectedDate, onSelect, days = 14 }) => {
  const scrollRef = useRef(null);
  const today = new Date();
  const dates = Array.from({ length: days }, (_, i) => addDays(today, i));

  const scrollBy = (offset) => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: offset, behavior: "smooth" });
  };

  return (
    <div className="flex items-center gap-2" data-testid="date-strip">
      <button
        type="button"
        onClick={() => scrollBy(-240)}
        className="hidden h-9 w-9 flex-shrink-0 items-center justify-center rounded-md border border-border text-muted-foreground hover:border-primary hover:text-primary sm:flex"
        aria-label="Jours précédents"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <div ref={scrollRef} className="flex gap-2 overflow-x-auto pb-1 scrollbar-thin">
        {dates.map((date) => {
          const dateStr = toDateString(date);
          const isSelected = dateStr === selectedDate;
          return (
            <button
              key={dateStr}
              type="button"
              onClick={() => onSelect(dateStr)}
              className={`flex min-w-[72px] flex-col items-center rounded-md border px-3 py-2 transition-colors duration-150 ${
                isSelected
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-card text-muted-foreground hover:border-[hsl(var(--studio-yellow)/0.5)]"
              }`}
              data-testid={`date-strip-${dateStr}`}
            >
              <span className="text-[11px] font-medium uppercase tracking-wide">
                {format(date, "EEE", { locale: fr })}
              </span>
              <span className="font-heading text-lg font-semibold tabular-nums">{format(date, "d")}</span>
              <span className="text-[11px] uppercase">{format(date, "MMM", { locale: fr })}</span>
            </button>
          );
        })}
      </div>
      <button
        type="button"
        onClick={() => scrollBy(240)}
        className="hidden h-9 w-9 flex-shrink-0 items-center justify-center rounded-md border border-border text-muted-foreground hover:border-primary hover:text-primary sm:flex"
        aria-label="Jours suivants"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};
